import * as Yup from 'yup'

export const ActionSchema = Yup.object().shape({
  action_type: Yup.string().required('Required'),
});
